<template>
  <div class="iframeContainer">
    <div id="game" class="game" @resize="onResize">
      <div class="close pointer">
<!--        <span>baidu</span>-->
        <span style="margin-right: auto;">{{$store.state.gameInfo.gameName}}</span>
        <!-- 2021-11-23 增加全屏和还原功能 -->
        <img src="@/assets/images/common/full_screen.png" class="screen-btn" v-show="!isFullScreen" alt="" @click="fullScreen">
        <img src="@/assets/images/common/exit_full_screen.png" class="screen-btn" v-show="isFullScreen" alt="" @click="exitFullScreen">
        <img :src="close" alt="" @click="handelClose">
      </div>
<!--      <iframe ref="iframe" src="https://www.baidu.com"></iframe>-->
      <iframe ref="iframe" :src="$store.state.gameInfo.gameUrl" v-bind:class="{fullscreen:isFullScreen}"></iframe>
    </div>
  </div>
</template>

<script>
import close from '@/assets/images/common/close.svg'
import {fetchBalance} from '@/utils'
import {mapMutations} from 'vuex'
export default {
  name: 'GameIframe',
  data () {
    return {
      close,
      isFullScreen: false
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.handelPlay()
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy () {
    // 移除监听器
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    ...mapMutations({
      setGameInfo: 'setGameInfo'
    }),
    fetchBalance,
    onResize () {
      let height = document.getElementById('game').offsetHeight
      if (height < (window.screen.height / 2)) {
        this.dbScreen()
      }
    },
    handelPlay () {
      var cid = localStorage.getItem('cid') // （注：从localstorage取出cid）
      window.gtag('config', 'UA-181768658-1', {'page_path': location.pathname})
      window.gtag('event', 'Play', {
        'event_category': this.$store.state.gameInfo.gameName,
        'event_label': cid
      })
    },
    handelClose () {
      this.fetchBalance()
      this.setGameInfo({showIframe: false})
    },
    dbScreen () {
      if (this.isFullScreen) {
        this.exitFullScreen()
      } else {
        this.fullScreen()
      }
    },
    fullScreen () {
      let element = document.getElementById('game')
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      } else {
        console.log('当前浏览器不支持全屏！')
        return
      }
      this.isFullScreen = true
    },
    exitFullScreen () {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      }
      this.isFullScreen = false
    }
  }
}
</script>

<style lang="less" scoped>
.iframeContainer {
  .game {
    width: 1125px;
    margin: 0 auto;
    border-radius: 6px;
    overflow: hidden;
    .close {
      /*position: fixed;*/
      /*top: 0;*/
      /*left: 0;*/
      /*width: 100%;*/
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      padding-left: 32px;
      font-size: 20px;
      color: #000;
      background: linear-gradient(27.63deg, #885400 -42.83%, #FFE4B9 101.74%);
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.25);
      .screen-btn {
        height: 18px;
      }
    }
    iframe {
      border: none;
      background-color: #F6D9AA;
      background-image: url("../../assets/images/common/loading.gif");
      background-size: 20%;
      background-repeat: no-repeat;
      background-position: center;
      width: 100%;
      height: 678px;
    }
    .fullscreen {
      width: 100%;
      height: calc(100% - 40px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GameIframe/index.vue